export const userSearchTabsList = [
  {
    title: "Пользователи",
    isActive: true,
    isFavorite: false,
    component: "UserSearchList",
  },
  {
    title: "Избранное",
    isActive: false,
    isFavorite: true,
    component: "UserSearchFavorites",
  },
  {
    title: "Статистика",
    isFavorite: false,
    isActive: false,
    isGeneralStatistics: true,
    component: "UserSearchGeneralStatistics",
  },
  {
    title: "Статистика по проектам",
    isActive: false,
    isFavorite: false,
    isProjectStatistics: true,
    component: "UserSearchProjectStatistics",
  },
  {
    title: "Статистика по образованию",
    isActive: false,
    isFavorite: false,
    isEducationStatistics: true,
    component: "UserSearchEducationStatistics",
  },
];